import { computed, inject, Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, catchError, Observable, tap, throwError } from "rxjs";
import { NotificationDto } from "../dto/notification";
import { NotificationType } from "../components/notification/notification.interface";

@Injectable({ providedIn: 'root' })
export class NotificationService {
    private BASE_URL = environment.api.url;

    private http = inject(HttpClient);

    // État partagé des notifications
    private notifications$ = new BehaviorSubject<NotificationDto[]>([]);

    // Observable public en lecture seule
    readonly notifications = this.notifications$.asObservable();

    // Computed pour le nombre de non lues
    readonly unreadCount = computed(() =>
        this.notifications$.value.filter(n => !n.read).length
    );

    getNotifications(key: NotificationType[] = ['all']): Observable<NotificationDto[]> {
        return this.http.get<NotificationDto[]>(`${this.BASE_URL}/notifications/`, {
            params: { key }
        }).pipe(
            tap(notifications => {
                if (key.includes('all')) {
                    this.notifications$.next(notifications);
                }
            }),
            catchError(error => throwError(() => error))
        );
    }

    updateNotificationStatus(id: string): Observable<void> {
        return this.http.patch<void>(`${this.BASE_URL}/notifications/${id}`, {}).pipe(
            tap(() => {
                const updated = this.notifications$.value.map(n =>
                    n.id === id ? { ...n, read: true } : n
                );
                this.notifications$.next(updated);
            }),
            catchError(error => throwError(() => error))
        );
    }
}